// Presentation copy only. Amounts, eligibility and provider content stay in their owners.
export default {
    es_MX: {
        loadFailedRetry: 'No se pudo cargar. Pulsa para reintentar.',
        close: 'Cerrar',
        installIntro: 'Elige la versión que prefieras para instalar la aplicación de {project} en tu dispositivo.',
        installIntroGeneric: 'Elige la versión que prefieras para instalar la aplicación en tu dispositivo.',
        fileSize: 'Tamaño',
        previousPage: 'Página anterior',
        nextPage: 'Página siguiente',
        downloadIntroGeneric: 'Elige la versión que prefieras para descargar e instalar la aplicación.',
        downloadTitle: 'Descargar aplicación',
        downloadIntro: 'Elige la versión que prefieras para descargar e instalar la aplicación de {project}.',
        downloadQuickIntro: 'Ideal para una descarga más rápida y una instalación ligera.',
        downloadNormalIntro: 'Descarga completa con todas las funciones.',
        type: 'Tipo',
        status: 'Estado',
        lossAmount: 'Pérdidas de ayer',
        betAmount: 'Apuestas de ayer',
        todayBonus: 'Bono de hoy',
        receive: 'Recibir',
        history: 'Historial',
        signinHistory: 'Historial de asistencia',
        dailyReward: 'Recompensa diaria',
        dailyIntro: 'Inicia sesión todos los días para recibir tu recompensa diaria. Alcanza un mayor nivel VIP para obtener recompensas más altas.',
        consecutiveDays: 'Días consecutivos',
        reward: 'Recompensa',
        date: 'Fecha',
        game: 'Juego',
        transaction: 'ID de transacción',
        prize: 'Premio',
        noSignin: 'No hay registros de asistencia',
        noSigninIntro: 'Aún no tienes registros. Inicia sesión todos los días para obtener recompensas.',
        currentPassword: 'Contraseña actual',
        newPassword: 'Nueva contraseña',
        confirmPassword: 'Confirmar contraseña',
        passwordIntro: 'Por tu seguridad, utiliza una contraseña única y que no compartas con otras cuentas.',
        accountSettings: 'Configuración de cuenta',
        accountIdIntro: 'Tu identificador en {project}.',
        phoneIntro: 'Utilizado para la verificación de tu cuenta.',
        passwordHint: 'Mantén tu cuenta segura con una contraseña única.',
        providers: 'Proveedores',
        providersIntro: 'Explora los juegos de nuestros proveedores.',
        depositTitle: 'Bono de depósito',
        depositIntro: 'Realiza un depósito y recibe hasta {percent}% en bono y {spins} FS en {stages} etapas.',
        bonusStages: 'Etapas del bono',
        bonus: 'en bono',
        freeSpins: 'giros gratuitos',
        wheelTitle: 'Ruleta de la suerte',
        wheelIntro: 'Usa tus puntos de la suerte para girar la ruleta y gana premios al instante.',
        wheelClassic: 'Ruleta clásica',
        wheelPrizes: 'Premios de esta ruleta',
        rules: 'Reglas del servicio',
        rulesPrizes: 'Reglas y premios',
        spin: 'Girar',
        opportunities: 'Tus oportunidades',
        inviteWheelTitle: 'Ruleta de invitación',
        inviteWheelIntro: 'Invita a tus amigos y gira la ruleta para ganar premios.',
        target: 'Importe objetivo',
        scratchTitle: 'Raspa y gana',
        scratchIntro: 'Raspa el panel y descubre tu premio.',
        price: 'Precio por jugada',
        envelopesTitle: 'Sobres diarios',
        envelopesIntro: 'Realiza el depósito requerido y recibe sobres en los horarios indicados.',
        requiredDeposit: 'Depósito requerido',
        depositedToday: 'Depositado hoy',
        envelope: 'Sobre',
        claimed: 'Reclamado',
        expired: 'Expirado',
        available: 'Disponible',
        lossTitle: 'Ayuda por pérdidas',
        lossIntro: 'Consulta el detalle y reclama tu bono de hoy de acuerdo con el importe de tus pérdidas de ayer.',
        rebateTitle: 'Reembolso de apuestas',
        rebateIntro: 'Consulta tu importe de apuestas y el bono adicional disponible.',
        signInTitle: 'Iniciar sesión',
        signUpTitle: 'Crear cuenta',
        signInIntro: 'Accede a tu cuenta para continuar disfrutando de tus juegos favoritos.',
        signUpIntro: 'Únete y comienza a jugar hoy mismo.',
        accountOrPhone: 'Teléfono o cuenta',
        phone: 'Código de país y teléfono',
        invitation: 'Código de invitación (opcional)',
        remembered: 'Recordarme en este dispositivo'
    },
    en_US: {
        loadFailedRetry: 'Unable to load. Tap to retry.',
        close: 'Close',
        installIntro: 'Choose your preferred version to install the {project} app on your device.',
        installIntroGeneric: 'Choose your preferred version to install the app on your device.',
        fileSize: 'Size',
        previousPage: 'Previous page',
        nextPage: 'Next page',
        downloadIntroGeneric: 'Choose your preferred version to download and install the app.',
        downloadTitle: 'Download the app',
        downloadIntro: 'Choose your preferred version to download and install the {project} app.',
        downloadQuickIntro: 'A faster download and a lightweight installation.',
        downloadNormalIntro: 'The complete download with all features.',
        type: 'Type',
        status: 'Status',
        lossAmount: 'Yesterday’s losses',
        betAmount: 'Yesterday’s bets',
        todayBonus: 'Today’s bonus',
        receive: 'Claim reward',
        history: 'History',
        signinHistory: 'Check-in history',
        dailyReward: 'Daily reward',
        dailyIntro: 'Sign in every day to receive your daily reward. Reach a higher VIP level to unlock higher rewards.',
        consecutiveDays: 'Consecutive days',
        reward: 'Reward',
        date: 'Date',
        game: 'Game',
        transaction: 'Transaction ID',
        prize: 'Prize',
        noSignin: 'No check-in records',
        noSigninIntro: 'You have no records yet. Sign in daily to earn rewards.',
        currentPassword: 'Current password',
        newPassword: 'New password',
        confirmPassword: 'Confirm password',
        passwordIntro: 'For your security, use a unique password you do not share with other accounts.',
        accountSettings: 'Account settings',
        accountIdIntro: 'Your identifier at {project}.',
        phoneIntro: 'Used to verify your account.',
        passwordHint: 'Keep your account safe with a unique password.',
        providers: 'Providers',
        providersIntro: 'Explore games from our providers.',
        depositTitle: 'Deposit bonus',
        depositIntro: 'Deposit and receive up to {percent}% bonus and {spins} FS in {stages} stages.',
        bonusStages: 'Bonus stages',
        bonus: 'bonus',
        freeSpins: 'free spins',
        wheelTitle: 'Lucky wheel',
        wheelIntro: 'Use your lucky points to spin the wheel and win prizes.',
        wheelClassic: 'Classic wheel',
        wheelPrizes: 'Prizes on this wheel',
        rules: 'Service rules',
        rulesPrizes: 'Rules and prizes',
        spin: 'Spin',
        opportunities: 'Your chances',
        inviteWheelTitle: 'Invitation wheel',
        inviteWheelIntro: 'Invite friends and spin the wheel to win prizes.',
        target: 'Target amount',
        scratchTitle: 'Scratch and win',
        scratchIntro: 'Scratch the panel to discover your prize.',
        price: 'Price per play',
        envelopesTitle: 'Daily envelopes',
        envelopesIntro: 'Make the required deposit and receive envelopes at the scheduled times.',
        requiredDeposit: 'Required deposit',
        depositedToday: 'Deposited today',
        envelope: 'Envelope',
        claimed: 'Claimed',
        expired: 'Expired',
        available: 'Available',
        lossTitle: 'Loss support',
        lossIntro: 'Check the details and claim today’s bonus based on yesterday’s losses.',
        rebateTitle: 'Betting rebate',
        rebateIntro: 'Check your betting amount and available extra bonus.',
        signInTitle: 'Sign in',
        signUpTitle: 'Create account',
        signInIntro: 'Access your account to enjoy your favorite games.',
        signUpIntro: 'Join and start playing today.',
        accountOrPhone: 'Phone or account',
        phone: 'Country code and phone',
        invitation: 'Invitation code (optional)',
        remembered: 'Remember me on this device'
    },
    pt_BR: {
        loadFailedRetry: 'Não foi possível carregar. Toque para tentar novamente.',
        close: 'Fechar',
        installIntro: 'Escolha a versão que prefere para instalar o aplicativo de {project} no seu dispositivo.',
        installIntroGeneric: 'Escolha a versão que prefere para instalar o aplicativo no seu dispositivo.',
        fileSize: 'Tamanho',
        previousPage: 'Página anterior',
        nextPage: 'Próxima página',
        downloadIntroGeneric: 'Escolha a versão que prefere para baixar e instalar o aplicativo.',
        downloadTitle: 'Baixar aplicativo',
        downloadIntro: 'Escolha a versão que prefere para baixar e instalar o aplicativo de {project}.',
        downloadQuickIntro: 'Ideal para um download rápido e uma instalação leve.',
        downloadNormalIntro: 'Download completo com todas as funcionalidades.',
        type: 'Tipo',
        status: 'Estado',
        lossAmount: 'Perdas de ontem',
        betAmount: 'Apostas de ontem',
        todayBonus: 'Bônus de hoje',
        receive: 'Resgatar',
        history: 'Histórico',
        signinHistory: 'Histórico de check-in',
        dailyReward: 'Recompensa diária',
        dailyIntro: 'Entre todos os dias para receber sua recompensa diária. Alcance um nível VIP maior para ganhar mais.',
        consecutiveDays: 'Dias consecutivos',
        reward: 'Recompensa',
        date: 'Data',
        game: 'Jogo',
        transaction: 'ID da transação',
        prize: 'Prêmio',
        noSignin: 'Nenhum registro de check-in',
        noSigninIntro: 'Entre todos os dias para ganhar recompensas.',
        currentPassword: 'Senha atual',
        newPassword: 'Nova senha',
        confirmPassword: 'Confirmar senha',
        passwordIntro: 'Para sua segurança, use uma senha única que não compartilhe com outras contas.',
        accountSettings: 'Configurações da conta',
        accountIdIntro: 'Seu identificador em {project}.',
        phoneIntro: 'Usado para verificar sua conta.',
        passwordHint: 'Mantenha sua conta segura com uma senha única.',
        providers: 'Provedores',
        providersIntro: 'Explore os jogos dos nossos provedores.',
        depositTitle: 'Bônus de depósito',
        depositIntro: 'Deposite e receba até {percent}% de bônus e {spins} FS em {stages} etapas.',
        bonusStages: 'Etapas do bônus',
        bonus: 'de bônus',
        freeSpins: 'rodadas grátis',
        wheelTitle: 'Roleta da sorte',
        wheelIntro: 'Use seus pontos da sorte para girar a roleta e ganhar prêmios.',
        wheelClassic: 'Roleta clássica',
        wheelPrizes: 'Prêmios desta roleta',
        rules: 'Regras do serviço',
        rulesPrizes: 'Regras e prêmios',
        spin: 'Girar',
        opportunities: 'Suas chances',
        inviteWheelTitle: 'Roleta de convites',
        inviteWheelIntro: 'Convide amigos e gire a roleta para ganhar prêmios.',
        target: 'Valor objetivo',
        scratchTitle: 'Raspe e ganhe',
        scratchIntro: 'Raspe o painel e descubra seu prêmio.',
        price: 'Preço por jogada',
        envelopesTitle: 'Envelopes diários',
        envelopesIntro: 'Faça o depósito necessário e receba envelopes nos horários indicados.',
        requiredDeposit: 'Depósito necessário',
        depositedToday: 'Depositado hoje',
        envelope: 'Envelope',
        claimed: 'Resgatado',
        expired: 'Expirado',
        available: 'Disponível',
        lossTitle: 'Ajuda por perdas',
        lossIntro: 'Confira os detalhes e resgate o bônus de hoje de acordo com as perdas de ontem.',
        rebateTitle: 'Reembolso de apostas',
        rebateIntro: 'Confira seu valor de apostas e o bônus adicional disponível.',
        signInTitle: 'Entrar',
        signUpTitle: 'Criar conta',
        signInIntro: 'Acesse sua conta para aproveitar seus jogos favoritos.',
        signUpIntro: 'Cadastre-se e comece a jogar hoje.',
        accountOrPhone: 'Telefone ou conta',
        phone: 'Código do país e telefone',
        invitation: 'Código de convite (opcional)',
        remembered: 'Lembrar neste dispositivo'
    },
    ru_RU: {
        loadFailedRetry: 'Не удалось загрузить. Нажмите, чтобы повторить.',
        close: 'Закрыть',
        installIntro: 'Выберите версию приложения {project} для установки на ваше устройство.',
        installIntroGeneric: 'Выберите версию приложения для установки на ваше устройство.',
        fileSize: 'Размер',
        previousPage: 'Предыдущая страница',
        nextPage: 'Следующая страница',
        downloadIntroGeneric: 'Выберите версию для загрузки и установки приложения.',
        downloadTitle: 'Скачать приложение',
        downloadIntro: 'Выберите версию для загрузки и установки приложения {project}.',
        downloadQuickIntro: 'Быстрая загрузка и лёгкая установка.',
        downloadNormalIntro: 'Полная версия со всеми функциями.',
        type: 'Тип',
        status: 'Статус',
        lossAmount: 'Вчерашние потери',
        betAmount: 'Вчерашние ставки',
        todayBonus: 'Бонус сегодня',
        receive: 'Получить',
        history: 'История',
        signinHistory: 'История отметок',
        dailyReward: 'Ежедневная награда',
        dailyIntro: 'Входите каждый день, чтобы получать награды. Повышайте уровень VIP для увеличения наград.',
        consecutiveDays: 'Дней подряд',
        reward: 'Награда',
        date: 'Дата',
        game: 'Игра',
        transaction: 'ID транзакции',
        prize: 'Выигрыш',
        noSignin: 'Отметок пока нет',
        noSigninIntro: 'Входите каждый день, чтобы получать награды.',
        currentPassword: 'Текущий пароль',
        newPassword: 'Новый пароль',
        confirmPassword: 'Подтвердите пароль',
        passwordIntro: 'Для безопасности используйте уникальный пароль, который не используется в других аккаунтах.',
        accountSettings: 'Настройки аккаунта',
        accountIdIntro: 'Ваш идентификатор в {project}.',
        phoneIntro: 'Используется для проверки аккаунта.',
        passwordHint: 'Защитите аккаунт уникальным паролем.',
        providers: 'Провайдеры',
        providersIntro: 'Откройте игры наших провайдеров.',
        depositTitle: 'Бонус за пополнение',
        depositIntro: 'Пополните баланс и получите до {percent}% бонуса и {spins} FS за {stages} этапа.',
        bonusStages: 'Этапы бонуса',
        bonus: 'бонус',
        freeSpins: 'бесплатные вращения',
        wheelTitle: 'Колесо удачи',
        wheelIntro: 'Используйте очки удачи для вращения колеса и получения призов.',
        wheelClassic: 'Классическое колесо',
        wheelPrizes: 'Призы этого колеса',
        rules: 'Правила сервиса',
        rulesPrizes: 'Правила и призы',
        spin: 'Крутить',
        opportunities: 'Ваши попытки',
        inviteWheelTitle: 'Колесо приглашений',
        inviteWheelIntro: 'Приглашайте друзей и вращайте колесо, чтобы получить призы.',
        target: 'Целевая сумма',
        scratchTitle: 'Сотрите и выиграйте',
        scratchIntro: 'Сотрите панель и узнайте свой приз.',
        price: 'Цена игры',
        envelopesTitle: 'Ежедневные конверты',
        envelopesIntro: 'Внесите необходимую сумму и получайте конверты в указанное время.',
        requiredDeposit: 'Необходимый депозит',
        depositedToday: 'Внесено сегодня',
        envelope: 'Конверт',
        claimed: 'Получено',
        expired: 'Истекло',
        available: 'Доступно',
        lossTitle: 'Поддержка при потерях',
        lossIntro: 'Проверьте сведения и получите бонус на основе вчерашних потерь.',
        rebateTitle: 'Возврат со ставок',
        rebateIntro: 'Проверьте сумму ставок и доступный дополнительный бонус.',
        signInTitle: 'Войти',
        signUpTitle: 'Создать аккаунт',
        signInIntro: 'Войдите в аккаунт, чтобы продолжить любимые игры.',
        signUpIntro: 'Присоединяйтесь и начните играть сегодня.',
        accountOrPhone: 'Телефон или аккаунт',
        phone: 'Код страны и телефон',
        invitation: 'Код приглашения (необязательно)',
        remembered: 'Запомнить на этом устройстве'
    }
}
